<template>
    <div class="hello" style="cursor: default">
      <div class="helloTop">
        <div class="one_1">企业培训数字化场景解决方案，快速提升企业人效</div>
        <div class="one_2">
          <div class="one_3">
            <div v-for="(item, i) in items" :key="i" :class="['one_4', activeName == i ? 'active' : '' ]" @mouseenter="handleClick(i)">
                <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; padding: 0 50px;">
                    <div style="display: flex;align-items: center;">
                        <img v-if="activeName == i" :src="item.imgg" alt="">
                        <img v-else :src="item.imgg2" alt="">
                        <div :class="['one_5', activeName == i ? 'active' : '' ]">{{ item.title }}</div>
                    </div>
                    <div :class="['one_6']">
                        <i class="el-icon-right"></i>
                    </div>
                </div>
            </div>
            <!-- <div
              v-for="(item, i) in items"
              :key="i"
              :class="['one_4', activeName == i ? 'active' : '']"
              @mouseenter="handleClick(i)"
            >
              <div class="one_5">{{ item.title }}</div>
              <div class="one_6">
                {{ item.components }}
              </div>
            </div> -->
          </div>
          <div class="Two_1">
            <div v-for="(item, i) in items" :key="i">
              <template v-if="i == activeName">
                <img :src="item.img" alt=""/>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "NewTalents",
    data() {
      return {
        activeName: "0",
        items: [
          {
            title: "人才规划",
            img: require("../assets/HelloWorld/a_1.png"),
            imgg:require('../assets/数字人/32.png'),
            imgg2:require('../assets/数字人/35.png'),
          },
          {
            title: "知识仓库",
            img: require("../assets/HelloWorld/cahngjing/c_1.png"),
            imgg:require('../assets/数字人/31.png'),
            imgg2:require('../assets/数字人/36.png'),
          },
          {
            title: "人才培训",
            img: require("../assets/HelloWorld/cahngjing/c_2.png"),
            imgg:require('../assets/数字人/34.png'),
            imgg2:require('../assets/数字人/37.png'),
          },
          {
            title: "人才分层",
            img: require("../assets/HelloWorld/cahngjing/c_3.png"),
            imgg:require('../assets/数字人/33.png'),
            imgg2:require('../assets/数字人/30.png'),
          },
        ],
      }
    },
    methods: {
      handleClick(i) {
        this.activeName = i
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
    // 隐藏滚动条
  *{
 ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
}
  .el-icon-right{
    color: #ec5c06;
    font-size: 24px;
  }
  .one_6 {
    width: 24px;
    border-radius: 50%;
    height: 24px;
    background: #ffffff;
  }
  .one_5 {
    height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    line-height: 28px;
    &.active{
      color: #ffffff;
    }
  }
  .hello {
    width: 100%;
    background: #F7FAFF;
    // height: 887px;
    display: flex;
    justify-content: center;
    .helloTop {
      height: 100%;
      .one_1 {
        font-size: 32px;
        font-weight: bold;
        color: #121221;
        margin: 50px 0 10px;
        text-align: center;
        height: 56px;
        font-size: 40px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 47px;
      }
      .one_2 {
        width: 1200px;
        // height: 490px;
        display: flex;
        justify-content: space-between;
        .one_3 {
            width: 435px;
            overflow-y: scroll;
            // background: #eb5b05;
            // height: 475px;
            padding: 40px 0;
          div:last-child {
            margin-bottom: 0;
          }
          .one_4 {
            background: #ffffff;
            margin:0 60px 20px;
            border-radius: 5px;
            overflow: hidden;
            transition: all 0.3s ease;
            height: 74px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
                width: 40px;
                // height: 30px;
                margin-right: 20px;
            }
            &.active {
              transition: all 0.3s ease;
            //   height: 262px;
              background: #eb5b05;
            }
   
      
          }
        }
        .Two_1 {
          width: 760px;
          // height: 490px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            // width: 680px;
            height: 372px;
            transform: scale(1);
            transition: all 0.3s ease;
          }
          img:hover{
            transform: scale(1.1);
            transition: all 0.3s ease;
          }
        }
      }
    }
  }

  </style>
  